export enum ComparingDatesEnum {
  Equal = 'EQUAL',
  Bigger = 'BIGGER',
  Smaller = 'SMALLER',
}
